<template>
  <div class="panel panel-default">
    <div class="panel-heading separator">
      <div class="panel-title">
        <h3>Demandes</h3>
      </div>
    </div>
    <div class="panel-body scrollable">
      <div class="locations-asking">
        <div class="table-responsive">
          <div id="basicTable_wrapper"
               class="dataTables_wrapper form-inline no-footer">
            <table class="table table-hover dataTable no-footer"
                   id="basicTable"
                   role="grid">
              <tbody>
                <one-time-locations-askings-item v-for="n in 154"
                                                 :key="n"></one-time-locations-askings-item>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .panel-title {
    display: flex !important;
  }
  
  .locations-asking {
    margin: 15px 0 0 0;
    min-width: 300px;
    max-height: 150px;
  }
</style>

<script type="text/babel">
  import OneTimeLocationsAskingsItem from './OneTimeLocationsAskingsItem.vue'
  export default {
    components: {
      OneTimeLocationsAskingsItem
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/OneTimeLocations/OneTimeLocationsAskings.vue